export { default } from './Animate';
export * from './Animate.types';
